import Item from '../api/item';

class DamageMap {
  constructor(options) {
    const defaults = {
      button: '.js-damage-map-choose-all',
      checkboxes: '.damage-map__checkbox',
      description: '#damage_description',
    }
    Object.assign(this, defaults, options);
  }

  init() {
    this._button = document.querySelector(this.button);
    this._checkboxes = document.querySelectorAll(this.checkboxes);
    this._button.addEventListener('click', this._chooseAll.bind(this));

    this._checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', this._updateDamageMapValues.bind(this));
    });

    this._description = document.querySelector(this.description);
    if(this._description) {
      this._description.addEventListener('change', this._updateDamageDescription.bind(this));
    }

    this._item = new Item(window.ITEM_ID);
  }

  /**
   * Makes all damage map checkboxes checked.
   *
   * @param {Event} event - The initiating event
   */
  _chooseAll(event) {
    event.preventDefault();

    this._checkboxes.forEach(checkbox => {
      checkbox.checked = true;
    });

    this._updateDamageMapValues();
  }

  /**
   * Creates an array of all the checked checkboxes' values,
   * and updates the item accordingly.
   */
  _updateDamageMapValues() {
    const checkedInputs = Array.from(this._checkboxes).filter(checkbox => checkbox.checked);
    const damage_map = checkedInputs.reduce((acc, checkbox) => [...acc, checkbox.value], []);


    const localized = checkedInputs.map(checkbox => {
      const label = document.querySelector(`label[for="${checkbox.id}"]`);
      return label ? label.innerText : null;
    });

    this._item.patch({ damage_map, damage_map__localized: localized }, false).then(res => {
      if(res.status === 'OK') {
        // great success!
      } else {
        // should we display a warning banner?
      }
    });
  }

  /**
   * Updates the item's damage_description field
   */
  _updateDamageDescription() {
    const damage_description = this._description.value;

    this._item.patch({ damage_description }, false).then(res => {
      if(res.status === 'OK') {
        // great success!
      } else {
        // should we display a warning banner?
      }
    })
  }
}


module.exports = DamageMap;
